import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as formReducer } from "redux-form";
import authorization from "./authorization";
import loaderReducer from "./loader";
import currentRideReducer from "./currentRide";
import snackbarReducer from "./snackbar";
import locationReducer from "./location";
import firebaseReducer from "./firebase";

export const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  form: formReducer,
  authorization,
  loader: loaderReducer,
  snackbar: snackbarReducer,
  currentRide: currentRideReducer,
  location: locationReducer,
  firebase: firebaseReducer,
});
